// ---------------------------------------------- modules import
import React, { FunctionComponent } from "react";
import { Link, useParams } from "react-router-dom";

import { IReaderListProps } from "./common";
import { useAuth, usePostForDetails } from "./hooks";
import { ThemeContext } from "../../../contexts/themeContext";
import PermissionHelper from "../../../store/helpers/permissionHelper";

// ---------------------------------------------- the component
const ReaderList: FunctionComponent<IReaderListProps> = ({ menuIndex }) => {
  // ---------------------------------------------- router state
  const { post_id } = useParams();

  // ---------------------------------------------- local state
  const { profile } = useAuth();
  const { post } = usePostForDetails(menuIndex, profile, post_id);

  const { id, title, category, readers } = post;

  // ---------------------------------------------- content
  return (
    <ThemeContext.Consumer>
      {({ theme }) => (
        <div className="container row">
          <div className="card col s12 m10 offset-m1">
            <div className="card-content" style={{ paddingBottom: "0px" }}>
              <span style={{ fontSize: "0.75rem" }}>
                {PermissionHelper.getName(menuIndex).toLowerCase()}
              </span>

              <span
                className={`new badge ${
                  category === "human resource"
                    ? "indigo accent-2"
                    : category === "operational"
                    ? "green accent-3"
                    : category === "administration"
                    ? "orange accent-2"
                    : category === "report"
                    ? "red accent-2"
                    : "purple accent-2"
                }`}
                data-badge-caption={category}
              />

              <span
                className="card-title center-align"
                style={{ marginTop: "12px" }}
              >
                {title.toUpperCase()}
              </span>

              <p style={{ fontSize: "0.75rem", marginTop: "10px" }}>
                This post has been read by the following users:{" "}
              </p>

              <ul className="collection">
                {readers.map(reader => (
                  <li key={reader.id} className="collection-item">
                    <span className="title">{reader.name}</span>
                    <p style={{ fontSize: "0.65rem" }}>{reader.email}</p>
                  </li>
                ))}
              </ul>
            </div>

            <div className="card-action row" style={{ marginBottom: "0" }}>
              <div className="col s6">
                <Link
                  to={`/${PermissionHelper.getUrl(menuIndex)}/${id}`}
                  className="btn-floating btn-small waves-effect waves-light"
                  style={{ backgroundColor: theme.ui }}
                >
                  <i className="material-icons left">arrow_back</i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </ThemeContext.Consumer>
  );
};

export default ReaderList;
